import React from 'react';

import { ButtonV2 } from '~/src/dash/components/buttons/ButtonV2';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  onClick: () => void;
}

export const CloseButton = ({ onClick }: IProps) => {
  return (
    <ButtonV2 small style={{ paddingLeft: '13px' }} clearBackground onClick={onClick}>
      <Cols gap='2px' style={{ alignItems: 'center' }}>
        <Col displayFlex paddingBottom='1px'>
          <IconV2 name='close' color={publicaColors.gray} large />
        </Col>
        <Col>Close</Col>
      </Cols>
    </ButtonV2>
  );
};
